import React from 'react'
import { TooltipNew } from '@elamajs/ui-kit'

import * as Styled from './Label.styled'

type Props = {
  label?: string
  isRequired?: boolean
  tooltip?: string
}

const Label = ({ label, tooltip, isRequired }: Props) => {
  return (
    <Styled.Label>
      {label && (
        <Styled.Text withTooltip={!!tooltip} isRequired={!!isRequired}>
          {label}
          {tooltip && (
            <Styled.Tooltip>
              <TooltipNew
                content={tooltip}
                icon="questionNew"
                direction="top-start"
                width="295px"
              />
            </Styled.Tooltip>
          )}
        </Styled.Text>
      )}
    </Styled.Label>
  )
}

export default Label
